import CardPage from "../../../layout/CardPage";
import Grafica from "./Grafica";

export default function PagosMes() {
    return (
        <CardPage>
            <Grafica />
        </CardPage>
    )
}